Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var _useSharedStyles2 = require("../Button/Label/styles/useSharedStyles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    colors = _STYLES$useStyles.colors,
    bp = _STYLES$useStyles.bp;
  var _useSharedStyles = (0, _useSharedStyles2.useSharedStyles)(),
    sharedStyles = _useSharedStyles.sharedStyles;
  var container = {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flex: 1
  };
  if (bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_normal])) {
    container.flexDirection = 'column';
  }
  var inputContainer = {
    marginBottom: 0,
    width: 'auto',
    flexShrink: 1
  };
  var input = {
    borderColor: colors.brand,
    borderWidth: (0, _styles.getREM)(0.125),
    backgroundColor: colors.brandContrast,
    height: 'auto',
    paddingTop: sharedStyles.label_normal.paddingTop,
    paddingBottom: sharedStyles.label_normal.paddingBottom,
    paddingLeft: sharedStyles.label_normal.paddingLeft,
    paddingRight: sharedStyles.label_normal.paddingRight,
    fontSize: sharedStyles.label_normal.fontSize,
    lineHeight: sharedStyles.label_normal.lineHeight,
    borderRadius: sharedStyles.label_normal.borderRadius
  };
  var actions = {
    flexDirection: 'row'
  };
  var styles = _reactNative.StyleSheet.create({
    container: container,
    inputContainer: inputContainer,
    input: input,
    actions: actions
  });
  return {
    styles: styles
  };
};